import { JoinInput, JoinPhoneInput } from '../items/joinInput';
import { InputBtn } from '../items/inputBtn';
import { Wrapper } from './tab.forgotId';
import { useState } from 'react';
import { ComplateFormFailed, ComplateFormSuccess } from './complate.form';
import { Button } from '../items/Button';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  passwordAuthSchema,
  passwordChangeSchema,
} from '../../schema/forgotSchema';
import { AlertModal } from '../modal/alert.modal';
import {
  newPassowrdRegist,
  requestPasswordAuth,
  verifyPasswordAuth,
} from '../../api/join';
import { formatPhoneNumber } from '../../utils/util';

export const ForgotPassword = () => {
  const [viewChange, setViewChange] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [complateView, setComplateView] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [phoneAuthUUID, setPhoneAuthUUID] = useState<string | null>(null); // 인증 UUID 상태 추가
  const [isPhoneVerified, setIsPhoneVerified] = useState(false); // 전화번호 인증 여부 상태 추가
  const [isPhoneDisabled, setIsPhoneDisabled] = useState(false);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null); // 타이머 상태 추가
  const [remainingTime, setRemainingTime] = useState(180); // 남은 시간(초) 상태 추가
  const history = useHistory();

  // 비밀번호 변경 폼
  const {
    register: registerPassword,
    handleSubmit: handleSubmitPassword,
    formState: { errors: passwordErrors },
  } = useForm({
    resolver: zodResolver(passwordChangeSchema),
  });

  // 인증 폼
  const {
    register: registerAuth,
    handleSubmit: handleSubmitAuth,
    formState: { errors: authErrors },
    getValues: getAuthValues,
    setValue: setAuthValues,
  } = useForm({
    resolver: zodResolver(passwordAuthSchema),
  });

  const goLogin = () => {
    history.push('/login');
  };

  const handleNextClick = (type: boolean) => {
    setIsSuccess(type);
    setViewChange(true);
  };

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }

    setRemainingTime(180); // 타이머 시작 시 3분 설정

    const newTimer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(newTimer);
          setPhoneAuthUUID(null);
          setModalMessage('인증 시간이 만료되었습니다. 다시 시도해주세요.');
          setIsModalOpen(true);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000); // 1초마다 타이머 업데이트

    setTimer(newTimer);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const phoneAuth = async () => {
    try {
      const phone = getAuthValues('phone');
      const passid = getAuthValues('passid');
      if (phone) {
        const uuid = await requestPasswordAuth(phone, passid);
        setPhoneAuthUUID(uuid);
        setModalMessage('인증번호가 전송되었습니다. 번호를 확인해주세요.');
        setIsModalOpen(true);
        startTimer(); // 타이머 시작
      } else {
        setModalMessage('휴대폰 번호를 입력해주세요.');
        setIsModalOpen(true);
      }
    } catch (error: any) {
      if (error.response && error.response.status === 409) {
        setModalMessage(
          '요청하신 핸드폰은 회원가입이 되어있지 않습니다. 회원가입을 진행해주세요.',
        );
      } else {
        console.error('휴대폰 본인 인증 요청 실패:', error);
        setModalMessage('입력하신 정보가 일치하지 않습니다.');
      }
      setIsModalOpen(true);
    }
  };

  const verifyAuthCode = async (authCode: string) => {
    if (!phoneAuthUUID) {
      setModalMessage('인증 시간이 만료되었습니다. 다시 시도해주세요.');
      setIsModalOpen(true);
      return;
    }

    try {
      await verifyPasswordAuth(phoneAuthUUID, authCode);
      setModalMessage('본인 인증에 성공하였습니다.');
      setIsModalOpen(true);
      setIsPhoneVerified(true);
      setIsPhoneDisabled(true);
      if (timer) {
        clearTimeout(timer); // 인증 성공 시 타이머 해제
      }
    } catch (error) {
      console.error('인증 실패:', error);
      setModalMessage('본인 인증 요청에 실패하였습니다.');
      setIsModalOpen(true);
    }
  };

  const onSubmitPasswordChange = async (data: any) => {
    try {
      if (phoneAuthUUID) {
        const statusCode = await newPassowrdRegist(
          phoneAuthUUID,
          data.password,
        );

        setComplateView(true);
      } else {
        setModalMessage('유효한 인증이 없습니다.');
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('비밀번호 변경 실패:', error);
      setModalMessage('비밀번호 변경에 실패했습니다.');
      setIsModalOpen(true);
    }
  };

  const onSubmitAuth = (data: any) => {
    console.log('Auth data:', data);
    if (!isPhoneVerified) {
      setModalMessage('휴대폰 번호 인증을 완료해주세요.');
      setIsModalOpen(true);
      return; // 인증이 완료되지 않은 경우 진행 중단
    }
    handleNextClick(true);
  };

  return (
    <Wrapper>
      {viewChange ? (
        isSuccess ? (
          complateView ? (
            <>
              <ComplateFormSuccess />
              <Button title="로그인 화면으로 이동" fiexd onClick={goLogin} />
            </>
          ) : (
            <div className="password-complate-form">
              <h4>새로운 비밀번호를 입력하세요.</h4>
              <form onSubmit={handleSubmitPassword(onSubmitPasswordChange)}>
                <JoinInput
                  label="새로운 비밀번호"
                  name="password"
                  type="password"
                  placeholder="비밀번호 입력"
                  errors={
                    passwordErrors.password?.message
                      ? [passwordErrors.password.message as string]
                      : []
                  }
                  register={registerPassword}
                />
                <JoinInput
                  label="비밀번호 확인"
                  name="passwordComfirm"
                  type="password"
                  placeholder="비밀번호 입력 확인"
                  errors={
                    passwordErrors.passwordComfirm?.message
                      ? [passwordErrors.passwordComfirm.message as string]
                      : []
                  }
                  register={registerPassword}
                />
                <InputBtn name="비밀번호 변경" type="submit" />
              </form>
              {/* <button
                onClick={() => {
                  setComplateView(true);
                }}
              >
                다음
              </button> */}
            </div>
          )
        ) : (
          <>
            <ComplateFormFailed />
            <Button title="로그인 화면으로 이동" fiexd onClick={goLogin} />
          </>
        )
      ) : (
        <div className="forgot-form">
          <h4>가입 당시 등록한 아이디와 휴대폰 번호를 입력해주세요.</h4>
          <form onSubmit={handleSubmitAuth(onSubmitAuth)}>
            <JoinInput
              name="passid"
              label="아이디"
              type="text"
              placeholder="아이디 입력"
              errors={
                authErrors.passid?.message
                  ? [authErrors.passid.message as string]
                  : []
              }
              register={registerAuth}
            />
            <JoinPhoneInput
              name="phone"
              label="휴대폰 번호"
              placeholder="휴대폰 번호 입력"
              type="text"
              btn
              btnTitle="본인인증"
              disabled={isPhoneDisabled}
              errors={
                authErrors.phone?.message
                  ? [authErrors.phone.message as string]
                  : []
              }
              register={registerAuth}
              validation={{
                onChange: (e: any) => {
                  const formattedValue = formatPhoneNumber(e.target.value);
                  setAuthValues('phone', formattedValue, {
                    shouldValidate: true,
                  });
                },
              }}
              onClick={phoneAuth}
              className={`input-disabled ${isPhoneDisabled ? 'disabled' : ''}`}
            />
            <div className="timer-wrapper">
              <JoinInput
                label="인증 번호"
                name="authCode"
                type="text"
                placeholder="인증 번호 입력"
                btn
                btnTitle="확인"
                errors={
                  authErrors.authCode?.message
                    ? [authErrors.authCode.message as string]
                    : []
                }
                register={registerAuth}
                onClick={() => verifyAuthCode(getAuthValues('authCode') || '')}
              />
              <p>
                남은 시간: {Math.floor(remainingTime / 60)}:
                {remainingTime % 60 < 10
                  ? `0${remainingTime % 60}`
                  : remainingTime % 60}
              </p>
            </div>
            <InputBtn name="다 음" type="submit" />
          </form>
          {/* <button
            onClick={() => {
              handleNextClick(true);
            }}
          >
            다음(성공)
          </button>
          <button
            onClick={() => {
              handleNextClick(false);
            }}
          >
            다음(실패)
          </button> */}
        </div>
      )}
      {isModalOpen && (
        <AlertModal
          handleConfirmClose={handleModalClose}
          confirmText={modalMessage}
          onClick={handleModalClose}
        />
      )}
    </Wrapper>
  );
};
